<template>
  <v-card flat class="settings-card">
    <v-container>
      <v-card-title class="settings-header-text">User Management</v-card-title>
      <v-container>
        <v-data-table
          :headers="headers"
          :items="users"
          :no-data-text="noUsersMessage"
          sort-by="firstName"
          class="elevation-0"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <!-- <v-select
                v-model="filterRoles"
                :items="userRoles"
                item-text="label"
                item-value="value"
                label="Filter Roles"
                placeholder="Showing all users"
                multiple
                chips
              ></v-select> -->
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    @click="onDialogOpen"
                    dark
                    class="mb-2"
                    v-on="on"
                    >New User</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }} User</span>
                    <v-spacer></v-spacer>
                    <v-btn text icon color="grey" @click="onClose">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="formValid">
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="editedItem.firstName"
                              required
                              :rules="[rules.required]"
                              label="First Name"
                              placeholder="First Name"
                              dense
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="editedItem.lastName"
                              required
                              :rules="[rules.required]"
                              label="Last Name"
                              placeholder="Last Name"
                              dense
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.email"
                              required
                              :rules="[rules.required]"
                              label="Email"
                              placeholder="Email"
                              dense
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.mobilePhoneNumber"
                              persistent-hint
                              hint="e.g. (555) 555-1212"
                              v-mask="masks.mobilePhone"
                              label="Mobile Phone"
                              placeholder="Mobile Phone"
                              dense
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-select
                              v-model="editedItem.authRoleId"
                              required
                              :rules="[rules.required]"
                              :items="authRoles"
                              item-text="label"
                              item-value="value"
                              label="Login"
                              placeholder="Login"
                              dense
                              outlined
                            ></v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              dense
                              v-model="editedItem.roles"
                              :items="userRoles"
                              item-text="label"
                              item-value="value"
                              label="Roles"
                              placeholder="Roles"
                              multiple
                              chips
                              dense
                              outlined
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="onSave">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.authRoleId="{ item }">
            {{
              authRoles.filter(obj => obj.value == item.authRoleId)[0]
                ? authRoles.filter(obj => obj.value == item.authRoleId)[0].label
                : "Unknown"
            }}
          </template>
          <template v-slot:item.roles="{ item }">
            {{ userRoles.filter(obj => obj.value == item.role)[0].label }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="onEditItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="onDeleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
import User from "../../models/User";
import { mask } from "vue-the-mask";
import { USER_ROLES, USER_AUTH_ROLES } from "../../globalVars";

export default {
  name: "UserManagement",
  components: {},
  directives: {
    mask
  },
  data: function() {
    return {
      dialog: false,
      formValid: true,
      headers: [
        {
          text: "Name",
          align: "start",
          value: "longName"
        },
        { text: "Email", value: "email" },
        { text: "Mobile Phone", value: "mobilePhoneNumber" },
        { text: "Login", value: "authRoleId" },
        // { text: "Roles", value: "roles" },
        { text: "Action", value: "actions", sortable: false }
      ],
      editedIndex: -1,
      editedItem: new User(),
      filterRoles: [],
      masks: {
        mobilePhone: "(###) ###-####"
      },
      rules: {
        required: value => !!value || "Required",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid email";
        },
        phone: value => {
          return (
            (value &&
              value.match(/\d/g) &&
              value.match(/\d/g).length >= 10 &&
              /^\d+$/.test(value.charAt(value.length - 1))) ||
            "Invalid phone number"
          );
        }
      }
    };
  },
  created() {
    this.$store.dispatch("entities/users/hydrate", 0);
  },
  computed: {
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    users() {
      let vueThis = this;
      let users = this.$store.getters["entities/users/query"]()
        .withAllRecursive(0)
        .get();
      if (vueThis.filterRoles.length > 0) {
        return users.filter(obj => {
          let matches = 0;
          if (obj.roles) {
            obj.roles.forEach(role => {
              if (vueThis.filterRoles.includes(role)) {
                matches++;
              }
            });
          }
          return matches == vueThis.filterRoles.length;
        });
      }
      return users;
    },
    userRoles() {
      return USER_ROLES;
    },
    authRoles() {
      return USER_AUTH_ROLES;
    },
    serverErrorMessage() {
      return this.settings ? this.settings.serverErrorMessage : null;
    },
    noUsersMessage() {
      let vueThis = this;
      return (
        "No users match " +
        this.userRoles
          .map(role => {
            return vueThis.filterRoles.includes(role.value) ? role.label : null;
          })
          .filter(x => x != null)
          .join(", ")
      );
    }
  },
  methods: {
    onEditItem(item) {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onDeleteItem(item) {
      if (confirm("Are you sure you want to delete this user?")) {
        item.isDirty = true;
        this.$store.dispatch("entities/users/deleteUser", item);
      }
    },
    onDialogOpen() {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onClose() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, new User());
        this.editedIndex = -1;
      }, 300);
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        let vueThis = this;
        this.$store.dispatch("entities/settings/update", {
          where: 1,
          data: {
            serverErrorMessage: ""
          }
        });
        if (this.editedItem && !this.editedItem.id) {
          this.editedItem.isDirty = true;
          await vueThis.$store.dispatch(
            "entities/users/createUser",
            vueThis.editedItem
          );
          // Edit User
        } else if (this.editedItem) {
          await vueThis.$store.dispatch(
            "entities/users/updateUser",
            vueThis.editedItem
          );
        }
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.onClose();
    },
    serverErrorMessage(val) {
      if (val) {
        alert(val);
      } else if (val == null) {
        this.onClose();
      }
    }
  }
};
</script>

<style scoped lang="stylus">
div.spacer {
  width: 3rem;
}
</style>
